<template>
  <v-container fluid fill-height class="home-hero">
    <v-layout justify-center align-center column pa-5>
      <div
        class="font-weight-black blue--text text--darken-2 text-center"
        :class="{
          'display-1': $vuetify.breakpoint.xs,
          'display-2': $vuetify.breakpoint.sm,
          'display-3':
            $vuetify.breakpoint.md ||
            $vuetify.breakpoint.lg ||
            $vuetify.breakpoint.xl
        }"
      >
        <p class="orange--text">404</p>
        <p>Page not found</p>
      </div>
    </v-layout>
  </v-container>
</template>
<script>
export default {
  name: 'NotFound'
}
</script>
<style scoped></style>
